import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PagingDTO } from '../../Shared/Models/PagingDTO';
import { PagingOptions } from '../../Shared/Models/PagingOptions';
import { RequestOptions, ResponseContentType, Headers } from '@angular/http';
import { Subject, Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { OnPagingFiltersChangeService } from '../../Shared/services/OnPagingFiltersChange.service';
import { FilterType } from '../../Shared/Enums/FilterType';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
  selector: 'BBSF-Paging',
  templateUrl: './Paging.component.html',
  styleUrls: ['./Paging.component.scss']
})
export class PagingComponent implements OnInit {
  items = [];
  pageOfItems: Array<any>;
  result: any = [];
  pagerConfig: any = null;
  totalRow: any = 0;
  pageSize: any = 10
  Pages: any = 0
  CurrentPage: any = 1
  ShowPageSizeOption = true;
  ShowFirstAndLast = true;
  hidePaginationWhenPageSizeEqualOne = true
  Sum = 0;
  Throttle = 300;
  ScrollDistance = 1;
  ScrollUpDistance = 2;
  direction = '';
  Headers:HttpHeaders;

  @Output() Items = new EventEmitter<any[]>();
  @Input() options: PagingOptions;

  @Input() group: FormGroup;


  constructor(private http: HttpClient, private router: Router, private onChangeService: OnPagingFiltersChangeService) {

  }

  ngOnInit() {
    if (this.options.IsLoadMoreControl)
    this.Sum = this.options.PageSize;

    if (this.options.DropdownFiltersControlNames != null && this.options.DropdownFiltersControlNames.length > 0) {
      const DropdownFiltersControlNames = this.options.DropdownFiltersControlNames;
      this.onChangeService.GetValue().subscribe((value) => {
        let result = this.options.DropdownFiltersControlNames.filter((item) => item == value)
        if (result.length > 0) {
          this.CurrentPage = 1;
          this.getItemList(this.CurrentPage, true);
        }
      })
    }

    if (this.options.BootstrapDatePickersFiltersControlNames != null && this.options.BootstrapDatePickersFiltersControlNames.length > 0) {
      const BootstrapDatePickersFiltersControlNames = this.options.BootstrapDatePickersFiltersControlNames;
      this.onChangeService.GetValue().subscribe((value) => {
        let result = this.options.BootstrapDatePickersFiltersControlNames.filter((item) => item == value)
        if (result.length > 0) {
          this.CurrentPage = 1;
          this.getItemList(this.CurrentPage, true);
        }
      })
    }


    this.getItemList(this.CurrentPage, true);
  }
  ngAfterViewInit(): void {

    if (this.options.OnClickFiltersControlNames != null && this.options.OnClickFiltersControlNames.length > 0) {
      const OnClickFiltersControlNames = this.options.OnClickFiltersControlNames;
      for (let index = 0; index < OnClickFiltersControlNames.length; index++) {
        const OnClickFiltersControlName = OnClickFiltersControlNames[index];
        document.getElementById(OnClickFiltersControlName).addEventListener("click", () => {
          this.CurrentPage = 1;
          this.getItemList(this.CurrentPage, true);
        }, false);
      }
    }
    if (this.options.OnKeyPressFiltersControlNames != null && this.options.OnKeyPressFiltersControlNames.length > 0) {
      const OnKeyPressFiltersControlNames = this.options.OnKeyPressFiltersControlNames;
      for (let index = 0; index < OnKeyPressFiltersControlNames.length; index++) {
        const OnKeyPressFiltersControlName = OnKeyPressFiltersControlNames[index];
        document.getElementById(OnKeyPressFiltersControlName).addEventListener("keypress", (e) => {
          if (e.key == "Enter") {
            this.CurrentPage = 1;
            this.getItemList(this.CurrentPage, true);
          }
        }, false);
      }
    }
    if (this.options.TypeaheadSearchControlNames != null && this.options.TypeaheadSearchControlNames.length > 0) {
      const TypeaheadSearchControlNames = this.options.TypeaheadSearchControlNames;
      for (let index = 0; index < TypeaheadSearchControlNames.length; index++) {
        const TypeaheadSearchControlName = TypeaheadSearchControlNames[index];
        document.getElementById(TypeaheadSearchControlName).addEventListener("keypress", (e) => {
          if (e.key == "Enter") {
            this.CurrentPage = 1;
            this.getItemList(this.CurrentPage, true);
          }
        }, false);

      }
    }

  }

  onDropDownChange(result) {
    if (result) {
      this.CurrentPage = 1;
      this.getItemList(this.CurrentPage, true);
    }
  }

  onChangePage(Page) {
    if(Page!=0)
    {
      this.CurrentPage = Page
      this.getItemList(Page);
    }
  
  }
  changePageSize(e) {
    debugger
    this.options.PageSize = e.target.value;
    this.CurrentPage = 1;
    this.getItemList(this.CurrentPage, true);
  }




  onScrollDown() {
    this.Sum += this.options.PageSize
    this.CurrentPage = 1
    this.direction = 'down';
    this.getItemList(this.CurrentPage, true);

  }



  getItemList(page, IsFilterUpdated = false) {
    debugger;
    let pagingDTO = new PagingDTO();
    let size = Number.parseInt(this.options.PageSize.toString());
    if (this.options.IsLoadMoreControl)
      pagingDTO.PageCount = this.Sum;
    else
      pagingDTO.PageCount = size;
    pagingDTO.CurrentPageNumber = page;
    pagingDTO.TotalCount = this.totalRow;
    pagingDTO.IsFilterUpdated = IsFilterUpdated;
    let params = new HttpParams();
    if (this.options.Filters != null && this.options.Filters != []) {
      for (let index = 0; index < this.options.Filters.length; index++) {
        if (this.options.Filters[index].FormControlName != null && this.options.Filters[index].FormControlName != "") {
          const FormControlName = this.options.Filters[index].FormControlName;
          let ControlValue = this.group.controls[FormControlName].value;
          if (ControlValue != undefined && ControlValue != null) {
            if (this.options.Filters[index].FilterType == FilterType.DatePicker) {
              if (Array.isArray(ControlValue)) {
                for (let element = 0; element < ControlValue.length; element++) {
                  const value = ControlValue[element];
                  params = params.append(this.options.Filters[index].ActionParameterName, value);
                }
              }
              else {
                params = params.append(this.options.Filters[index].ActionParameterName, ControlValue);
              }
            }
            else {
              if (this.options.Filters[index].FilterType == FilterType.AutocompleteTextBox)
                ControlValue = JSON.stringify(ControlValue);
              params = params.append(this.options.Filters[index].ActionParameterName, ControlValue);
            }
          }
        }
        else {
          const ElementjQuerySelector = this.options.Filters[index].jQuerySelector;
          let ElementValue = (document.querySelector(ElementjQuerySelector) as HTMLInputElement).value;
          if (ElementValue != undefined && ElementValue != null)
            params = params.append(this.options.Filters[index].ActionParameterName, ElementValue);
        }
      }
    }

    if(this.options.ValidationToken!=null)
    {
    
      this.Headers=new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': this.options.ValidationToken
      })
    }

    this.http.post(`${this.options.ActionPostURL}`, pagingDTO, { params: params,headers:this.Headers })
      .subscribe((responseData: any) => {
        this.result = responseData.items;
        this.Items.emit(this.result);
        if (IsFilterUpdated) {
          this.items = [];
          this.totalRow = responseData.totalCount;
          this.Pages = Math.ceil((this.totalRow / this.options.PageSize));
          this.items = Array(this.totalRow);
        }
      });
  }

  ReinitializePaging=()=>{
    this.getItemList(this.CurrentPage, true);
  }
 
  UpdatePaging=()=>{
    this.getItemList(this.CurrentPage);
  }
 


}
